import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT } from "../../constants/constants";
import { getDbHeader } from "../../utils2024/utils";

const useGetRegLinks = () => {
  return useQuery({
    queryKey: ["get-reg-links"],
    queryFn: async () => {
      // Adjust the endpoint base path if your route is nested (e.g., /event/get-reg-links)
      const response = await axios.get(
        `${API_ENDPOINT}/event/get-reg-links`,
        getDbHeader()
      );
      return response.data;
    },
    retry: (failureCount, error) => {
      if (!error.response) return true;
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500;
    },
  });
};

export default useGetRegLinks;
